import { LazyLoader } from '@bp/ui-components';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

export const BaseOutlet = () => {
  return (
    <Suspense fallback={<LazyLoader embedded transparent forceHeight='50vh' />}>
      <Outlet />
    </Suspense>
  );
};
